module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container clearfix",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "bottom-desc"
  }, [_c('p', [_vm._v("职人联盟，找人雇猎头，就上OKLIE")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "copy-right"
  }, [_vm._v("©2020 oklie.cn. All Rights Reserved")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5343dbb6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/happypack/loader.js?id=ESLint!./app/components/Footer.vue
// module id = 43
// module chunks = 0 1 2 3 4